import { render, staticRenderFns } from "./my-task-task.vue?vue&type=template&id=6f1221c8&scoped=true&"
import script from "./my-task-task.vue?vue&type=script&lang=ts&"
export * from "./my-task-task.vue?vue&type=script&lang=ts&"
import style0 from "./my-task-task.vue?vue&type=style&index=0&id=6f1221c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1221c8",
  null
  
)

export default component.exports